import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
} from 'react-admin';
import ResourceTitle from './ResourceTitle';

const ResourceShow = props => (
    <Show title={<ResourceTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <ReferenceField label="Environment" source="environment_id" reference="environments">
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Azure storage" source="azure_storage_id" reference="azure_storages">
                <TextField source="account_name" />
            </ReferenceField>
            <TextField source="type" />
            <ReferenceField label="Database Item" source="database_item_id" reference="database_items">
                <TextField source="hostname" />
            </ReferenceField>
            <TextField source="group_name" />
            <ReferenceField label="Azure auth" source="azure_authentication_id" reference="azure_authentications">
                <TextField source="name" />
            </ReferenceField>

        </SimpleShowLayout>
    </Show>
);

export default ResourceShow;